import { render, staticRenderFns } from "./SetupProgress.vue?vue&type=template&id=226caa4e&"
import script from "./SetupProgress.vue?vue&type=script&lang=js&"
export * from "./SetupProgress.vue?vue&type=script&lang=js&"
import style0 from "./SetupProgress.vue?vue&type=style&index=0&id=226caa4e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports